import { getCookie } from "./cookieUtils";
import { CheckCircle, Eye, EyeOff, Lock, RotateCcw, Save, XCircle } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginBox from "./LoginBox";
import TrackingBox from "./TrackingBox";
import { encryptPassword } from "./Encrypt";

const ChangePassword = () => {
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [loginToken, setLoginToken] = useState(getCookie("loginToken") || null);
    const [userName, setUserName] = useState(getCookie("userName") || "");
    const [accessType, setAccessType] = useState(getCookie("accessType") || "");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });

    const policyValidations = {
        noWhitespace: formData.newPassword.length > 0 && !/\s/.test(formData.newPassword),
        length: formData.newPassword.length >= 8 && formData.newPassword.length <= 15,
        matchConfirmPassword: formData.newPassword.length > 0 && formData.newPassword === formData.confirmPassword,
        differentOldPassword: formData.oldPassword.length > 0 && formData.oldPassword !== formData.newPassword,
        complexity: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$#@!()])/.test(formData.newPassword)
    };

    const isValid = Object.values(policyValidations).every(Boolean);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        setFormData({ oldPassword: "", newPassword: "", confirmPassword: "" });
        setTimeout(() => {
            if (inputrefs.current["txtOldPassword"]) inputrefs.current["txtOldPassword"].focus();
        }, 0);
    };

    const apiConfig = {
        AuthToken: "NASSKD28462RWKF35793FWEU757",
        LoginUserCode: userName,
        LoginToken: loginToken,
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const payload = {
                ...apiConfig,
                oldPassword: formData.oldPassword,
                newPassword: formData.newPassword,
                confirmPassword: formData.confirmPassword
            };
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/UserLogin/ChangePassword`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data?.status === "SUCCESS" || data?.Status === "SUCCESS") {
                toast.success(data?.message || data?.Message);
                handleReset();
            } else {
                toast.error(data?.message || data?.Message);
                const focusField = data?.focus || data?.Focus;
                if (focusField && inputrefs.current[focusField]) {
                    inputrefs.current[focusField].focus();
                }
            }
        } catch {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleLoginSuccess = (loginData) => {
        setLoginToken(loginData.loginToken);
        setUserName(loginData.userName);
        setAccessType(loginData.accessType);
    };

    const PolicyRow = ({ label, valid }) => (
        <li style={{
            display: "flex", alignItems: "flex-start", justifyContent: "space-between",
            gap: "10px", padding: "8px 0", borderBottom: "1px solid #f3f4f6",
            fontSize: "13px", color: "#374151", lineHeight: "1.5"
        }}>
            <span style={{ flex: 1 }}>{label}</span>
            <span style={{ flexShrink: 0, marginTop: "2px" }}>
                {valid
                    ? <CheckCircle size={16} style={{ color: "#16a34a" }} />
                    : <XCircle size={16} style={{ color: "#dc2626" }} />
                }
            </span>
        </li>
    );

    useEffect(() => {
        inputrefs.current["txtOldPassword"].focus();
    }, []);

    return (
        <>
<section>
                <div className="container-fluid">
                    <img src="images/innerbanner.webp" className="img-fluid" alt="" />
                </div>
            </section>

            <section className="main-section">
                <div className="container">
                    <div className="row g-4">

                        {/* SIDEBAR */}
                        <div className="col-lg-3">
                            <TrackingBox />
                            <LoginBox onLoginSuccess={handleLoginSuccess} />
                            <div className="contact-card">
                                <div className="contact-title">Contact</div>
                                <div className="contact-item">
                                    <div className="contact-icon phone"><i className="fa fa-phone"></i></div>
                                    <a href="tel:01141606842">+91 96672 33072</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email"><i className="fa fa-envelope"></i></div>
                                    <a href="#">oxford_express@yahoo.co.in</a>
                                </div>
                                <div className="contact-item">
                                    <div className="contact-icon email"><i className="fa fa-envelope"></i></div>
                                    <a href="#">info@oxfordexp.com</a>
                                </div>
                            </div>
                        </div>

                        {/* MAIN CONTENT */}
                        <div className="col-lg-9">

                            {/* Outer wrapper card */}
                            <div style={{
                                background: "#fff", border: "1px solid #e5e7eb",
                                borderRadius: "10px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
                                overflow: "hidden"
                            }}>
                                {/* Red top header bar */}
                                <div style={{
                                    background: "#dc2626", padding: "10px 20px",
                                    display: "flex", alignItems: "center", gap: "8px"
                                }}>
                                    <Lock size={18} color="#fff" />
                                    <span className="fs-5 text-white">
                                        Change Password
                                    </span>
                                </div>

                                {/* Two-column grid */}
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    minHeight: "300px"
                                }}>

                                    {/* LEFT — Form */}
                                    <div style={{ padding: "24px 28px", borderRight: "1px solid #f0f0f0" }}>

                                        <div className="space-y-4">

                                            {/* OLD PASSWORD */}
                                            <div className="mb-3">
                                                <div className="login-field mb-0">
                                                <label>Old Password</label>
                                                <div className="position-relative">
                                                    <input
                                                        id="txtOldPassword"
                                                        ref={(el) => (inputrefs.current["txtOldPassword"] = el)}
                                                        type={showPassword.old ? "text" : "password"}
                                                        name="oldPassword"
                                                        className="track-input m-0"
                                                        style={{ paddingRight: "40px" }}
                                                        placeholder="Enter Old Password"
                                                        value={formData.oldPassword}
                                                        onChange={handleChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current["txtNewPassword"]?.focus();
                                                            }
                                                        }}
                                                    />
                                                    <span
                                                        className="position-absolute cursor-pointer"
                                                        style={{ right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#6b7c99" }}
                                                        onClick={() =>
                                                            setShowPassword((prev) => ({ ...prev, old: !prev.old }))
                                                        }
                                                    >
                                                        {showPassword.old ? <EyeOff size={18} /> : <Eye size={18} />}
                                                    </span>
                                                </div>
                                                </div>
                                            </div>

                                            {/* NEW PASSWORD */}
                                            <div className="mb-3">
                                                <div className="login-field mb-0">
                                                <label>New Password</label>
                                                <div className="position-relative">
                                                    <input
                                                        id="txtNewPassword"
                                                        ref={(el) => (inputrefs.current["txtNewPassword"] = el)}
                                                        type={showPassword.new ? "text" : "password"}
                                                        name="newPassword"
                                                        className="track-input m-0"
                                                        style={{ paddingRight: "40px" }}
                                                        placeholder="Enter New Password"
                                                        value={formData.newPassword}
                                                        onChange={handleChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current["txtConfirmPassword"]?.focus();
                                                            }
                                                        }}
                                                    />
                                                    <span
                                                        className="position-absolute cursor-pointer"
                                                        style={{ right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#6b7c99" }}
                                                        onClick={() =>
                                                            setShowPassword((prev) => ({ ...prev, new: !prev.new }))
                                                        }
                                                    >
                                                        {showPassword.new ? <EyeOff size={18} /> : <Eye size={18} />}
                                                    </span>
                                                </div>
                                                </div>
                                            </div>

                                            {/* CONFIRM PASSWORD */}
                                            <div className="mb-3">
                                                <div className="login-field mb-0">
                                                <label>Confirm Password</label>
                                                <div className="position-relative">
                                                    <input
                                                        id="txtConfirmPassword"
                                                        ref={(el) => (inputrefs.current["txtConfirmPassword"] = el)}
                                                        type={showPassword.confirm ? "text" : "password"}
                                                        name="confirmPassword"
                                                        className="track-input m-0"
                                                        style={{ paddingRight: "40px" }}
                                                        placeholder="Confirm Password"
                                                        value={formData.confirmPassword}
                                                        onChange={handleChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                inputrefs.current["btnSub"]?.focus();
                                                            }
                                                        }}
                                                    />
                                                    <span
                                                        className="position-absolute cursor-pointer"
                                                        style={{ right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#6b7c99" }}
                                                        onClick={() =>
                                                            setShowPassword((prev) => ({ ...prev, confirm: !prev.confirm }))
                                                        }
                                                    >
                                                        {showPassword.confirm ? <EyeOff size={18} /> : <Eye size={18} />}
                                                    </span>
                                                </div>
                                                </div>
                                            </div>


                                        </div>

                                        {/* Action buttons */}
                                        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                            <button id="btnSub" type="submit" className="track-btn" disabled={loading} onClick={handleSubmit} ref={(el) => (inputrefs.current["btnSub"] = el)}>
                                                <i className="fa fa-save me-1"></i>
                                                Save
                                            </button>
                                            <button type="button" className="login-btn" onClick={handleReset}>
                                                <i className="fa fa-undo me-1"></i> Reset
                                            </button>
                                        </div>
                                    </div>

                                    {/* RIGHT — Policy Panel */}
                                    <div className="p-3 rounded" style={{ display: "flex", flexDirection: "column" }}>
                                        {/* Blue policy header */}
                                        <div style={{ background: "#991b1b", padding: "10px 20px" }}>
                                            <span style={{ color: "#fff", fontWeight: 600, fontSize: "13.5px" }}>
                                                Password Policy
                                            </span>
                                        </div>
                                        <div className="bg-light rounded" style={{ padding: "14px 20px 20px", flex: 1 }}>
                                            <ol style={{ listStyle: "decimal", paddingLeft: "16px", margin: 0 }}>
                                                <PolicyRow
                                                    label="White spaces not allowed."
                                                    valid={policyValidations.noWhitespace}
                                                />
                                                <PolicyRow
                                                    label="Password must be 8 to 15 character(s)."
                                                    valid={policyValidations.length}
                                                />
                                                <PolicyRow
                                                    label="New password and confirm password should be same."
                                                    valid={policyValidations.matchConfirmPassword}
                                                />
                                                {/*<PolicyRow*/}
                                                {/*    label="Old password and new password should be different."*/}
                                                {/*    valid={policyValidations.differentOldPassword}*/}
                                                {/*/>*/}
                                                <PolicyRow
                                                    label="Password must contain at least one number, uppercase, lowercase and special character [$#!()]."
                                                    valid={policyValidations.complexity}
                                                />
                                            </ol>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* STATS STRIP */}
            <section className="stats-strip">
                <div className="container">
                    <div className="row g-0 text-center">
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">4.5L+</div>
                            <div className="stat-label">Packets / Month</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">1000+</div>
                            <div className="stat-label">Cities Covered</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">35+</div>
                            <div className="stat-label">Years Experience</div>
                        </div>
                        <div className="col-6 col-md-3 stat-item py-2">
                            <div className="stat-number">10K+</div>
                            <div className="stat-label">Happy Clients</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChangePassword;
